import React from 'react';
import PropTypes from 'prop-types';

import { CHAT_ROLES } from '../utils';

const NewUserMessage = ({ userMessage }) => (
  <li className={`messages__msg ${CHAT_ROLES.USER}`}>
    <div className="messages__msg_container">
      <p className={`messages__msg_content ${CHAT_ROLES.USER}`}>{userMessage}</p>
    </div>
  </li>
);

NewUserMessage.propTypes = {
  userMessage: PropTypes.string.isRequired,
};

export default NewUserMessage;
